import { RestEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';
import store from 'state/RootReducer';
import { ProfileActions } from 'state/profile/Action';

/**
 * get profile using method GET /profile
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getProfile = async (): Promise<any> =>
    APIManager.sendGet(RestEnds.PROFILE, true, {}, {}, axios);

/**
 * load profile to corresponding dispatcher in redux
 */
const loadProfile = (): void => {
    getProfile().then((response) => {
        const { data } = response.data;
        store.dispatch(ProfileActions.setProfileData(data));
    });
};
/**
 * Send 2FA for initialization using method POST /2fa/setup
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const setupTwoFactor = async (): Promise<any> =>
    APIManager.sendPost(RestEnds.SETUP_2FA, {}, true, {}, {}, axios);
/**
 * Send 2FA for confirmation using method POST /2fa/confirmation
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const confirmTwoFactor = async (data: any): Promise<any> =>
    APIManager.sendPost(RestEnds.CONFIRM_TWO_FA, data, true, {}, {}, axios);

/**
 * Send 2FA for verification using method POST /2fa/verify
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const securityVerification = async (data: any): Promise<any> =>
    APIManager.sendPost(
        RestEnds.SECURITY_VERIFICATION,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Patch 2FA to reset status using method PATCH /2fa/reset
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resetTwoFactor = async (): Promise<any> =>
    APIManager.sendPatch(RestEnds.RESET_TWO_FA, {}, true, {}, {}, axios);
/**
 * Patch User Profile using method PATCH /edit-profile
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const updateProfile = async (data: any): Promise<any> =>
    APIManager.sendPatch(RestEnds.EDIT_PROFILE, data, true, {}, {}, axios);
/**
 * Patch User Password using method PATCH /change-password
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const changePassword = async (data: any): Promise<any> =>
    APIManager.sendPatch(RestEnds.CHANGE_PASSWORD, data, true, {}, {}, axios);
/**
 * Patch to toggle 2FA configuration using method PATCH /2fa/config
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const toggleTwoFactor = async (data: any): Promise<any> =>
    APIManager.sendPatch(RestEnds.TOGGLE_TWO_FA, data, true, {}, {}, axios);

export const UserSettingService = {
    getProfile,
    loadProfile,
    updateProfile,
    changePassword,
    setupTwoFactor,
    confirmTwoFactor,
    resetTwoFactor,
    toggleTwoFactor,
    securityVerification,
};
